<template>
  <div class="container col-10">
    <div class="ContainerRecordatorio">
      <div class="ContainerRecorda">
        <v-icon color="#f88623" x-large>mdi-alert-circle</v-icon>
        <p>
          <span>
            Recuerda que una vez iniciada la monetización, los canjes estarán
            atados al reporte generado.
          </span>
        </p>
      </div>
      <div class="correoEnvio">
        <v-text-field
          class="big-label"
          color="secondary"
          label="Enviar archivo de solicitud"
          v-model="maskEmail"
          readonly
          disabled
        ></v-text-field>
      </div>
    </div>

    <div class="headerReport">
      <div v-if="this.loading" class="text-center">
        <v-progress-circular
          class="mt-auto"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <v-data-table
        v-else
        :headers="headers"
        :items="monetizacionStartList.previewData"
        :header-props="{ class: 'red-header' }"
        :search="searchTerm"
      >
        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50px; margin-left: 67px">
            <div class="row justify-space-between mx-auto">
              <v-text-field
                label="Buscador"
                placeholder="Ingrese por favor una palabra"
                append-icon="mdi-magnify"
                dense
                outlined
                class="col-md-5"
                @input="search"
              ></v-text-field>

              <div class="btn">
                <template>
                  <v-btn
                    x-medium
                    large
                    block
                    rounded
                    color="primary"
                    dark
                    v-if="monetizacionStartList.previewData?.length > 0"
                    @click="ActivateDownloadOrSendEmailMonetization"
                  >
                    Iniciar Monetización
                  </v-btn>
                </template>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:[`item.displayName`]="{ item }">
          <span class="custom-font">{{ item.displayName }}</span>
        </template>

        <template v-slot:[`item.emailAddress`]="{ item }">
          <span class="custom-font">{{ item.emailAddress }}</span>
        </template>

        <template v-slot:[`item.identificationNumber`]="{ item }">
          <span class="custom-font">{{ item.identificationNumber }}</span>
        </template>

        <template v-slot:[`item.requestDate`]="{ item }">
          <span class="custom-font">{{ item.requestDate }}</span>
        </template>

        <template v-slot:[`item.amountToMonetize`]="{ item }">
          <span class="custom-font">{{
            formatCurrency(item.amountToMonetize)
          }}</span>
        </template>
      </v-data-table>
      <div class="totalSolicitudesContainer">
        <p class="totalSolicitudes">
          Total de solicitudes:
          {{ monetizacionStartList?.previewData?.length || 0 }}
        </p>
      </div>
    </div>

    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          style="bottom: 50px; right: 20px"
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          :disabled="!activateButtons"
          @click="handleDownloadOrSendEmail(false)"
        >
          <v-icon dark>mdi-email-outline</v-icon>
        </v-btn>
      </template>
      <span>Enviar por correo</span>
    </v-tooltip>

    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          style="bottom: 120px; right: 20px"
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          :disabled="!activateButtons"
          @click="handleDownloadOrSendEmail(true)"
        >
          <v-icon dark>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>Descargar</span>
    </v-tooltip>
  </div>
</template>

<script>
import Swal from "sweetalert2";

import {
  REPORTS_M,
  ACTION_GET_START_MONETIZATIONS,
  ACTION_EMAIL_SEND_MONETIZATION,
  ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS,
  GET_LOADING_MONETIZATIONS,
  GET_START_LIST_MONETIZATION,
  GET_EMAIL_SEND_MONETIZATION,
} from "@/views/reports/store/types/types.js";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "detailReportComponent",
  data() {
    return {
      formData: {
        startDate: null,
        endDate: null,
        company: null,
      },
      searchTerm: "",
      isDownload: null,
      activateButtons: false,
      activePicker: null,
      activePicker2: null,
      totalRegistros: 20,
      modoRules: [(v) => !!v || "El modo de la categoría es requerido"],
      showErrorMessages: false,
      dialog: false,
    };
  },

  async mounted() {
    await this.getEmailSendMonetization();
    await this.getListStartMonetization();
  },

  computed: {
    headers() {
      return [
        {
          text: "Usuario",
          value: "displayName",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Correo",
          value: "emailAddress",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Identificación",
          value: "identificationNumber",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Fecha de solicitud",
          value: "requestDate",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1 my-custom-font",
        },

        {
          text: "Valor a monetizar",
          value: "amountToMonetize",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          align: "center",
          //class: "custom-header mdi-pencil text-subtitle-1",
        },
      ];
    },

    ...mapGetters({
      monetizacionStartList: [`${REPORTS_M}${GET_START_LIST_MONETIZATION}`],
      emailSendMonetization: [`${REPORTS_M}${GET_EMAIL_SEND_MONETIZATION}`],
      loading: `${REPORTS_M}${GET_LOADING_MONETIZATIONS}`,
    }),

    maskEmail() {
      if (!this.emailSendMonetization) {
        return "";
      }
      return this.emailSendMonetization;
    },
  },

  methods: {
    search() {
      // Actualiza el término de búsqueda
      this.searchTerm = event.target.value;
    },

    redirectToDownload(link) {
      const downloadUrl = link;
      window.open(downloadUrl.data.payload, "_blank");
    },

    formatCurrency(value) {
      if (!value) return "0"; // Evita mostrar "undefined"
      return new Intl.NumberFormat("es-ES").format(value);
    },

    ActivateDownloadOrSendEmailMonetization() {
      Swal.fire({
        icon: "info",
        title: "Procesando...",
        html: "Se ha procesado el documento.<br>En la parte inferior derecha podrá descargarlo o enviarlo a su correo.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: "Entendido",
        confirmButtonColor: "#6E17A5",
        didOpen: () => {
          document.querySelector(".swal2-icon").style.color = "#6E17A5";
          document.querySelector(".swal2-icon").style.borderColor = "#6E17A5";
        },
      });
      this.activateButtons = true;
    },

    async handleDownloadOrSendEmail(isDownload) {
      const link = await this.getDowloadOrSendEmail(isDownload);
      if (isDownload) {
        await this.redirectToDownload(link);
      } else {
        await Swal.fire({
          text: "Revisar el documento enviado al correo",
          icon: "success",
          confirmButtonText: "OK"
        });
      }
      this.activateButtons = false;
      await window.location.reload();
    },

    ...mapActions({
      getListStartMonetization: `${REPORTS_M}${ACTION_GET_START_MONETIZATIONS}`,
      getEmailSendMonetization: `${REPORTS_M}${ACTION_EMAIL_SEND_MONETIZATION}`,
      getDowloadOrSendEmail: `${REPORTS_M}${ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS}`,
    }),
  },
};
</script>

<style lang="css" scoped>
.headerReport {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-bottom: 40px;
}

p span {
  color: #6e17a5;
  font-weight: bold;
  font-size: 15px;
}

.custom-font {
  font-size: 20px;
}

.totalSolicitudesContainer {
  position: fixed;
  bottom: 5px;
}

.totalSolicitudes {
  font-weight: bold;
  color: #6e17a5;
  font-size: 23px;
}

.ContainerRecorda {
  background-color: #ff770048;
  width: 92%;
  height: 75px;
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
  padding-left: 15px;
}

.ContainerRecordatorio {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin: 20px 0px;
}

.ContainerRecordatorio p {
  margin-bottom: 0 !important;
}

.correoEnvio {
  align-self: flex-start;
  margin-left: 75px;
}

@media screen and (max-width: 550px) {
  .headerReport {
    margin: 40px 10px;
  }

  p span {
    font-size: 12px;
  }
}
</style>
